import { useCallback, useMemo } from "react";

import {
	useCartActions,
	useCartContext,
} from "../../contexts/CartServiceContext/CartServiceContext";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { useDineInTakeawayButton } from "../CartPage/CartHeader/useDineInTakeawayButton";

export const usePLPDineInTakeaway = () => {
	const {
		state: { show_initial_takeaway_selection },
	} = useConfigContext((state) => state.config);

	const {
		state: { initial_takeaway_selection },
	} = useCartContext((state) => state);
	const action = useCartActions();

	useDineInTakeawayButton();

	const hideDineInTakeaway = useCallback(() => {
		action.INITIAL_TAKEAWAY_SELECTED();
	}, []);

	const show = useMemo(() => {
		// if flag "show_initial_takeaway_selection" is set to FALSE explicitly, then don't show the prompt
		if (show_initial_takeaway_selection === undefined || show_initial_takeaway_selection) {
			return initial_takeaway_selection;
		}

		return false;
	}, [show_initial_takeaway_selection, initial_takeaway_selection]);

	return {
		showDineInTakeaway: show,
		hideDineInTakeaway,
	};
};
